(() => {
  document.addEventListener("DOMContentLoaded", function () {
    const openers = document.querySelectorAll(
      '[data-bs-toggle="modal"]'
    );
    const modal = document.getElementById("myModal");
    const modalDialog = modal.querySelector(".modal-dialog");
    const closeButtons = modal.querySelectorAll(".btn-close");
    const backdrop = document.getElementById("myBackdrop");
    const modalBody = document.querySelector(".modal-body");
    let mouseDownTarget = null;

    openers.forEach((button) => {
      button.addEventListener("click", openModal);
    });

    modal.addEventListener("mousedown", function (e) {
      mouseDownTarget = e.target;
    });

    modal.addEventListener("mouseup", function (e) {
      if (
        mouseDownTarget === modal &&
        !modalDialog.contains(e.target)
      ) {
        closeModal();
      }
    });

    closeButtons.forEach(function (btn) {
      btn.addEventListener("click", closeModal);
    });

    function openModal(event) {
      modalBody.innerHTML =
        event.target.dataset.content ||
        event.currentTarget.dataset.content;
      modal.classList.add("show");
      modal.style.display = "block";
      if (!backdrop) return;
      backdrop.classList.add("show");
      backdrop.style.display = "block";
    }

    function closeModal() {
      const video = modalBody.querySelector("video");
      if (video) video.pause();
      modal.classList.remove("show");
      modal.style.display = "none";
      if (!backdrop) return;
      backdrop.classList.remove("show");
      backdrop.style.display = "none";
    }
  });
})();